import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {OAuthService} from 'angular-oauth2-oidc';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private oauthSvc: OAuthService,
  ) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe((err) =>
      err.pipe(
        catchError((data) =>
          throwError(() => {
            console.error(data);

            if ([404, 403].includes(data.status) || data.status >= 500) {
              const {
                error: {localizedMessage},
              } = data;
              sessionStorage.setItem(
                'error.description',
                localizedMessage || ''
              );

              //this.router.navigate([this.localization.locale, data.status]);
              
              return data
            }

            if (data.status === 401) {
              this.oauthSvc.refreshToken()
                  .then((token) => {
                    localStorage["access_token"] = token.access_token;
                  })
                  .catch(() => {
                    const {pathname, search} = location;
                    const path = pathname.split('/').splice(2).join('/');
                    this.oauthSvc.initCodeFlow(`${path}${search}`);
                  })
              const customError = {...data}
              customError['messages'] = [data.error ,`${data.message} Please try again`];
              return customError;
            }
            return data;
          })
        )
      )
    );
  }
}
